import _ from 'lodash'
import { DebugSocketStateEnum } from 'enums'
export default {
  isDebuggerConnected: state => (): boolean => {
    return !_.isEmpty(state.debugSocket) && state.debugSocketState === DebugSocketStateEnum.OPENED
  }
}
